export default "__VITE_ASSET__CQyJPDU5__"